<template>
  <div class="sale-setup">
    <Loader v-model="loading" />
    <PrinterDialog v-model="printer" :impresoras="impresoras" />

    <!-- ================== MODO TELÉFONO (tipo.valor == 1) ================== -->
    <div v-if="tipo.valor == 1" class="inline-form open">
      <!-- Teléfono con búsqueda (SIEMPRE VISIBLE) -->
      <div class="field">
        <div class="phone-field">
          <div class="field">
            <label for="telefonoDom">Teléfono</label>
            <v-combobox
              id="telefonoDom"
              class="rd-input"
              :readonly="disabledView"
              item-text="strTelefono"
              item-value="strTelefono"
              :items="clientes.data"
              placeholder="Buscar…"
              outlined
              rounded
              dense
              :return-object="false"
              v-model="localValue.strTelefono"
              append-outer-icon="mdi-account-search"
              @click:append-outer="buscar()"
            />
          </div>
          <datalist id="clientesDomList">
            <option
              v-for="(c, i) in clientes.data"
              :key="i"
              :value="c.strTelefono"
            ></option>
          </datalist>
        </div>
      </div>

      <!-- Nombre (SIEMPRE VISIBLE) -->
      <div class="field">
        <label for="nombreDom">Nombre</label>
        <input
          id="nombreDom"
          type="text"
          :readonly="disabledView"
          v-model="localValue.strNombre"
        />
      </div>

      <!-- Botón para expandir/colapsar detalle -->
      <div class="field field-toggle">
        <button
          type="button"
          class="toggle-btn"
          @click="mostrarDetalle = !mostrarDetalle"
        >
          <v-icon small>{{
            mostrarDetalle ? "mdi-chevron-up" : "mdi-chevron-down"
          }}</v-icon>
          {{ mostrarDetalle ? "Ocultar datos" : "Más datos" }}
        </button>
      </div>

      <!-- ====== CAMPOS ADICIONALES (solo si mostrarDetalle) ====== -->
      <template v-if="mostrarDetalle">
        <!-- Repartidor (solo si estatus > 1) -->
        <div v-if="POSEnc.intEstatus > 1" class="field">
          <label for="repartidor">Repartidor</label>
          <select id="repartidor" v-model="localValue.intEmpleado">
            <option :value="null" disabled>Selecciona…</option>
            <option
              v-for="r in repartidores"
              :key="r.intEmpleado"
              :value="r.intEmpleado"
            >
              {{ r.strNombreCompleto }}
            </option>
          </select>
        </div>

        <!-- Calle y número -->
        <div class="field">
          <label for="dirDom">Calle y número</label>
          <input
            id="dirDom"
            type="text"
            :readonly="disabledView"
            v-model="localValue.strDireccion"
          />
        </div>

        <!-- Colonia (autocomplete) -->
        <div class="field">
          <label for="coloniaDom">Colonia</label>
          <v-autocomplete
            class="rd-input"
            :readonly="disabled"
            v-model="localValue.strColonia"
            :items="colonias"
            item-text="strColonia"
            item-value="strColonia"
            label="Colonia"
            outlined
            rounded
            :return-object="false"
            dense
            no-data-text="No existe Colonia"
          />
          <datalist id="coloniasDomList">
            <option
              v-for="(c, i) in colonias"
              :key="i"
              :value="c.strColonia"
            ></option>
          </datalist>
        </div>

        <!-- Entre calles -->
        <div class="field">
          <label for="entreDom">Entre calles</label>
          <input
            id="entreDom"
            type="text"
            :readonly="disabledView"
            v-model="localValue.strEntreCalle"
          />
        </div>

        <!-- Referencias -->
        <div class="field">
          <label for="refDom">Referencias</label>
          <input
            id="refDom"
            type="text"
            :readonly="disabledView"
            v-model="localValue.strReferencia"
          />
        </div>

        <!-- Municipio -->
        <div class="field">
          <label for="munDom">Municipio</label>
          <input
            id="munDom"
            type="text"
            :readonly="disabledView"
            v-model="localValue.strPoblacion"
          />
        </div>

        <!-- EXT / Teléfono 2 -->
        <div class="field">
          <label for="extDom">EXT, Teléfono 2</label>
          <input
            id="extDom"
            type="text"
            :readonly="disabledView"
            v-model="localValue.strTelefono2"
          />
        </div>
      </template>
    </div>

    <!-- ================== MODO RFC (tipo.valor == 2) ================== -->
    <div v-if="tipo.valor == 2" class="inline-form open">
      <!-- RFC (SIEMPRE VISIBLE) -->
      <div class="field">
        <label for="rfcDom">RFC</label>
        <div class="phone-field">
          <div class="field-grow">
            <input
              id="rfcDom"
              type="text"
              :readonly="disabled"
              v-model="localValue.strRFC"
            />
          </div>
          <button
            type="button"
            class="lookup-btn"
            :disabled="disabled"
            @click="buscarRFC()"
            aria-label="Buscar por RFC"
          >
            <v-icon small>mdi-account-search</v-icon>
          </button>
        </div>
      </div>

      <!-- Nombre (SIEMPRE VISIBLE) -->
      <div class="field">
        <label for="nombreRfc">Nombre</label>
        <input
          id="nombreRfc"
          type="text"
          :readonly="disabled"
          v-model="localValue.strNombre"
        />
      </div>

      <!-- Botón toggle -->
      <div class="field field-toggle">
        <button
          type="button"
          class="toggle-btn"
          @click="mostrarDetalle = !mostrarDetalle"
        >
          <v-icon small>{{
            mostrarDetalle ? "mdi-chevron-up" : "mdi-chevron-down"
          }}</v-icon>
          {{ mostrarDetalle ? "Ocultar datos" : "Más datos" }}
        </button>
      </div>

      <!-- ====== CAMPOS ADICIONALES ====== -->
      <template v-if="mostrarDetalle">
        <!-- Calle -->
        <div class="field">
          <label for="calleRfc">Calle</label>
          <input
            id="calleRfc"
            type="text"
            :readonly="disabled"
            v-model="localValue.strDireccion"
          />
        </div>

        <!-- # Ext -->
        <div class="field">
          <label for="extRfc"># Ext</label>
          <input
            id="extRfc"
            type="text"
            :readonly="disabled"
            v-model="localValue.strNumeroExterior"
          />
        </div>

        <!-- # Int -->
        <div class="field">
          <label for="intRfc"># Int</label>
          <input
            id="intRfc"
            type="text"
            :readonly="disabled"
            v-model="localValue.strNumeroInterior"
          />
        </div>

        <!-- Colonia (solo si rowColonia) -->
        <div v-show="rowColonia" class="field">
          <label for="coloniaRfc">Colonia</label>
          <input
            id="coloniaRfc"
            type="text"
            :readonly="disabled"
            v-model="localValue.strColonia"
            placeholder="Buscar…"
            list="coloniasRfcList"
          />
          <datalist id="coloniasRfcList">
            <option
              v-for="(c, i) in colonias"
              :key="i"
              :value="c.strColonia"
            ></option>
          </datalist>
        </div>

        <!-- Municipio -->
        <div class="field">
          <label for="munRfc">Municipio</label>
          <input
            id="munRfc"
            type="text"
            :readonly="disabled"
            v-model="localValue.strPoblacion"
          />
        </div>

        <!-- Teléfono -->
        <div class="field">
          <label for="telRfc">Teléfono</label>
          <input
            id="telRfc"
            type="text"
            :readonly="disabled"
            v-model="localValue.strTelefono"
          />
        </div>

        <!-- Correo -->
        <div class="field">
          <label for="correoRfc">Correo</label>
          <input
            id="correoRfc"
            type="text"
            :readonly="disabled"
            v-model="localValue.strCorreoElectronico"
          />
        </div>
      </template>
    </div>

    <!-- ================== Botones ================== -->
    <div v-show="divBotones" class="form-actions">
      <button
        v-if="!disabledView"
        type="button"
        class="small-btn"
        @click="save()"
      >
        Guardar
      </button>
      <button
        v-if="disabled"
        type="button"
        class="small-btn"
        @click="saleRepa()"
      >
        Sale Repa
      </button>
    </div>

    <!-- Buscar cliente modal -->
    <BuscarCliente
      :version="tipo.valor"
      :colonias="colonias"
      @clienteSeleccionado="seleccionarCliente"
      v-model="buscarCliente"
    />
  </div>
</template>

<script>
import {
  Session,
  Toast,
  ErrorWeb,
  Dialog,
  Data,
} from "../controllers/DataController.js";
import Loader from "./Loader.vue";
import {
  POSEncFunctions,
  POSLogImpresion,
  POSCliente,
} from "../controllers/POSController.js";
import BuscarCliente from "./BuscarClienteComponent.vue";
import PrinterDialog from "./PrinterDialogComponent.vue";
import Cookies from "js-cookie";

export default {
  name: "DomicilioForm",
  props: {
    value: { required: true },
    disabled: { type: Boolean, default: true },
    repartidores: { type: Array, default: () => [] },
    colonias: { type: Array, default: () => [] },
    tipo: { type: Object, default: () => ({}) },
    orden: { default: 0 },
    impresoras: { type: Array, default: () => [] },
    POSInfo: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      session: new Session(),
      dataController: new Data(),
      loading: false,
      localValue: this.value,
      telefonoBusqueda: "",
      POSEnc: this.orden,
      ordenFunctions: new POSEncFunctions(this.$config.api_backend_route),
      buscarCliente: { isVisible: false, data: [] },
      config: this.$config.opciones.find((c) => c.id == 1),
      printer: new Dialog(0, 0, "", "", ""),
      log: new POSLogImpresion(new Session(), this.$config.api_backend_route),
      POSCliente: new POSCliente(),
      clientes: [],
      items: [],
      search: null,
      colonia: this.colonias,
      rowColonia: true,
      divBotones: true,
      config_17: this.$config.opciones.find((c) => c.id == 17).valor,
      showRepartidor: false,
      disabledView: true,
      mostrarDetalle: false, // <-- NUEVO: controla visibilidad de campos extra
    };
  },
  components: { Loader, BuscarCliente, PrinterDialog },
  watch: {
    "POSEnc.intEstatus": "checkStatus",
    search(val) {
      val && this.querySelections(val);
    },
    orden(newValue) {
      this.POSEnc = newValue;
    },
    localValue(newValue) {
      this.$emit("input", newValue);
    },
    loading(newValue) {
      this.$emit("loading", newValue);
    },
    value(newValue) {
      this.localValue = newValue;
    },
    colonias(newValue) {
      this.colonia = newValue;
    },
    async ["localValue.strTelefono"](newVal) {
      if (newVal && this.tipo.valor == 1) {
        let data = await this.ordenFunctions.dataclientes(newVal);
        if (data != undefined) {
          this.localValue.intCliente = data.intCliente;
          this.localValue.strColonia = data.strColonia;
          this.localValue.strDireccion = data.strDireccion;
          this.localValue.strEntreCalle = data.strEntreCalle;
          this.localValue.strNombre = data.strNombre;
          this.localValue.strNumeroExterior = data.strNumeroExterior;
          this.localValue.strNumeroInterior = data.strNumeroInterior;
          this.localValue.strPoblacion = data.strPoblacion;
          this.localValue.strReferencia = data.strReferencia;
          this.localValue.strTelefono = data.strTelefono;
          this.localValue.strRFC = data.strRFC;
        } else {
          this.localValue.intCliente = 0;
          this.localValue.strColonia = "";
          this.localValue.strDireccion = "";
          this.localValue.strEntreCalle = "";
          this.localValue.strNombre = "";
          this.localValue.strNumeroExterior = "";
          this.localValue.strNumeroInterior = "";
          this.localValue.strPoblacion = "";
          this.localValue.strReferencia = "";
        }
      }
    },
    async ["localValue.strRFC"](newVal) {
      if (newVal && this.tipo.valor == 2) {
        let data = await this.ordenFunctions.buscarClienteRFC(newVal);
        if (data != undefined) {
          this.localValue.intCliente = data.intCliente;
          this.localValue.strColonia = data.strColonia;
          this.localValue.strDireccion = data.strDireccion;
          this.localValue.strEntreCalle = data.strEntreCalle;
          this.localValue.strNombre = data.strNombre;
          this.localValue.strNumeroExterior = data.strNumeroExterior;
          this.localValue.strNumeroInterior = data.strNumeroInterior;
          this.localValue.strPoblacion = data.strPoblacion;
          this.localValue.strReferencia = data.strReferencia;
          this.localValue.strRFC = data.strRFC;
        } else {
          this.localValue.intCliente = "";
          this.localValue.strColonia = "";
          this.localValue.strDireccion = "";
          this.localValue.strEntreCalle = "";
          this.localValue.strNombre = "";
          this.localValue.strNumeroExterior = "";
          this.localValue.strNumeroInterior = "";
          this.localValue.strPoblacion = "";
          this.localValue.strReferencia = "";
          this.localValue.strRFC = "";
        }
      }
    },
    async ["localValue.strColonia"](newVal) {
      if (newVal) {
        if (this.config_17) {
          const encontrada = this.colonia.find(
            (element) => element.strColonia == newVal
          );
          this.POSEnc.dblEnvio1 = encontrada ? encontrada.dblEnvio : null;
        } else {
          this.POSEnc.dblEnvio1 = 0;
        }
      }
    },
  },
  async mounted() {
    this.clientes.data = await this.ordenFunctions.clientes(
      this.localValue.strTelefono
    );
    let config_21 = this.$config.opciones.find((c) => c.id == 21);
    if (config_21.valor) {
      this.rowColonia = false;
      this.divBotones = false;
    } else {
      this.rowColonia = true;
      this.divBotones = true;
    }
    await this.checkStatus();
  },
  methods: {
    async checkStatus() {
      try {
        if (!this.$config || !Array.isArray(this.$config.opciones)) {
          console.error("Config opciones no está definido o no es un array");
          return;
        }
        let config_31 = this.$config.opciones.find((c) => c.id === 31);
        if (config_31 && this.POSEnc.intEstatus >= config_31.valor) {
          this.disabledView = true;
        } else {
          this.disabledView = false;
        }
      } catch (error) {
        console.error("Error en checkStatus:", error);
      }
    },
    querySelections(v) {
      this.loading = true;
      setTimeout(() => {
        this.items = this.clientes.data.filter((e) => {
          return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
        });
        this.loading = false;
      }, 500);
    },
    async save() {
      this.loading = true;
      try {
        if (this.localValue.intCliente > 0) {
          await this.ordenFunctions.editarCliente(
            this.localValue,
            this.session.empresa,
            this.session.usuario,
            this.session.terminal
          );
          this.$toast.success("Cliente actualizado con exito", new Toast());
        } else {
          if (this.tipo.valor == 1) {
            if (this.localValue.strColonia == "")
              throw "Favor de seleccionar colonia";
            if (this.localValue.strTelefono == "")
              throw "Favor de agregar Telefono";
            if (this.localValue.strNombre == "")
              throw "Favor de agregar Nombre";
            if (this.localValue.strDireccion == "")
              throw "Favor de agregar Direccion";
            if (this.localValue.strEntreCalle == "")
              throw "Favor de agregar Entre Calle";
          }
          let response = await this.ordenFunctions.saveCliente(
            this.localValue,
            this.session.empresa,
            this.session.usuario,
            this.session.terminal
          );
          this.localValue.intCliente = response.intCliente;
          this.$toast.success("Cliente agregado con exito", new Toast());
        }

        // 👇 NUEVO: colapsar el detalle al guardar con éxito
        this.mostrarDetalle = false;
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },
    async saleRepa() {
      if (this.localValue.intEmpleado > 0) {
        let repa = this.repartidores.find(
          (x) => x.intEmpleado == this.localValue.intEmpleado
        );
        this.localValue.strRepartidor = repa.strNombreCompleto;
        this.localValue.dblDomicilioPagaCon = this.POSEnc.dblPagaCon;
        this.localValue.intPOSEnc = this.POSEnc.intPOSEnc;

        let POSEnc2 = await this.ordenFunctions.retrieve_id(
          this.POSEnc.intPOSEnc
        );
        if (this.POSEnc.intEstatus !== 3) {
          this.$emit("saleRepa", this.localValue);
        } else {
          this.localValue.strUsuarioMod = POSEnc2.strUsuarioMod;
          let posMOd = this.localValue.strUsuarioMod;
          let strUsuarioMod = Cookies.get("POS_USER");
          if (strUsuarioMod === "" || strUsuarioMod === null) {
            strUsuarioMod = Cookies.get("POS_USER");
          }
          if (posMOd === "" || posMOd === null) {
            posMOd = Cookies.get("POS_USER");
          }
          posMOd = posMOd.toUpperCase();
          strUsuarioMod = strUsuarioMod.toUpperCase();
          if (posMOd === strUsuarioMod || !strUsuarioMod) {
            this.$emit("saleRepa", this.localValue);
          } else {
            if (this.POSEnc.intEstatus === 3) {
              this.$toast.error("Ya se dio salida a Repartidor", new Toast());
            } else {
              this.$toast.error(
                "El usuario que registro la orden debe dar salida",
                new Toast()
              );
            }
          }
        }
      } else {
        this.$toast.error("Favor de asignar repartidor", new Toast());
      }
    },
    async buscar() {
      if (!this.disabledView) {
        this.loading = true;
        try {
          if (this.localValue.strTelefono == "")
            this.localValue.strTelefono = this.session.empresa;

          this.buscarCliente.data = await this.ordenFunctions.clientes(
            this.localValue.strTelefono
          );
          this.buscarCliente.isVisible = true;
        } catch (e) {
          this.$toast.error(ErrorWeb(e), new Toast());
        } finally {
          this.loading = false;
        }
      }
    },
    async buscarRFC() {
      if (!this.disabled) {
        this.loading = true;
        try {
          this.buscarCliente.data = await this.ordenFunctions.buscarClienteRFC(
            this.localValue.strRFC
          );
          this.buscarCliente.isVisible = true;
        } catch (e) {
          this.$toast.error(ErrorWeb(e), new Toast());
        } finally {
          this.loading = false;
        }
      }
    },
    seleccionarCliente(cliente) {
      this.buscarCliente.isVisible = false;
      this.localValue = cliente;
    },
    convertDateJSON(POSEnc) {
      if (POSEnc.datFecha.toString().includes("T")) {
        return POSEnc.datFecha;
      } else {
        let x = POSEnc.datFecha.split(" ");
        let y = x[0].split("/");
        return y[2] + "-" + y[1] + "-" + y[0] + "T" + x[1] + ".511Z";
      }
    },
  },
};
</script>

<style scoped>
/* ==== Contenedor general del formulario ==== */
.sale-setup {
  --primary: #0353a4;
  --primary-hover: #034582;
  --primary-light: #347ea8;
  --primary-tint: #eef5f9;
  --surface: #fff;
  --surface-alt: #fafbfc;
  --border: #e2e4e8;
  --border-strong: #c7cbd1;
  --text: #1a1d23;
  --muted: #6b7280;
  --r-sm: 8px;
  --r-md: 14px;

  position: relative;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  box-shadow: 0 3px 12px rgba(17, 29, 45, 0.045);
  padding: 15px 17px;
  color: var(--text);
}

.inline-form {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px 11px;
}
.inline-form.open {
  display: grid;
}
.inline-form .field {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.field label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 4px;
  color: var(--text);
}

/* Inputs y selects nativos */
.field input,
.field select {
  width: 100%;
  height: 42px;
  box-sizing: border-box;
  padding: 8px 11px;
  border: 1.5px solid var(--border-strong);
  border-radius: var(--r-sm);
  background: var(--surface);
  color: var(--text);
  font: inherit;
  font-size: 13px;
}
.field input::placeholder {
  color: var(--muted);
}
.field input:focus,
.field select:focus,
.field input:focus-visible,
.field select:focus-visible {
  outline: none;
  border-color: var(--primary-light);
  box-shadow: 0 0 0 5px rgba(52, 126, 168, 0.18);
}
.field input[readonly] {
  background: var(--surface-alt);
  color: var(--muted);
  cursor: not-allowed;
}

/* Botones */
.phone-field {
  display: flex;
  gap: 8px;
  align-items: stretch;
}
.phone-field .field-grow {
  flex: 1;
  min-width: 0;
}
.lookup-btn {
  height: 42px;
  min-width: 42px;
  border: 1.5px solid var(--primary);
  border-radius: var(--r-sm);
  background: #fff;
  color: var(--primary);
  font-weight: 700;
  font-size: 11px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}
.lookup-btn:hover:not(:disabled) {
  background: var(--primary-tint);
}
.lookup-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.form-actions {
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}
.small-btn {
  min-height: 44px;
  background: var(--primary);
  color: #fff;
  border: 0;
  border-radius: var(--r-sm);
  padding: 10px 18px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.small-btn:hover {
  background: var(--primary-hover);
}

/* ===== Botón toggle "Más datos" ===== */
.field-toggle {
  justify-content: flex-end;
}
.toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 42px;
  padding: 0 14px;
  border: 1.5px dashed var(--border-strong);
  border-radius: var(--r-sm);
  background: var(--surface-alt);
  color: var(--primary);
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, border-color 0.15s;
}
.toggle-btn:hover {
  background: var(--primary-tint);
  border-color: var(--primary-light);
}

/* =========================================================
   Ajuste fino a los componentes Vuetify (v-combobox, v-autocomplete)
   ========================================================= */
.rd-input ::v-deep .v-input__control,
.rd-input.v-input {
  min-height: auto;
}

.rd-input ::v-deep .v-input__slot {
  margin-bottom: 0 !important;
}

.rd-input ::v-deep .v-input__slot fieldset,
.rd-input.v-text-field--outlined.v-input--dense ::v-deep fieldset {
  border-color: var(--border-strong) !important;
  border-width: 1.5px !important;
  border-radius: var(--r-sm) !important;
}

.rd-input ::v-deep .v-input__slot,
.rd-input.v-text-field--outlined ::v-deep .v-input__slot {
  min-height: 42px !important;
  height: 42px !important;
  padding: 0 11px !important;
  border-radius: var(--r-sm) !important;
}

.rd-input ::v-deep input {
  font-family: inherit !important;
  font-size: 13px !important;
  color: var(--text) !important;
  padding: 0 !important;
}

.rd-input ::v-deep .v-label {
  font-family: inherit !important;
  font-size: 12px !important;
  color: var(--muted) !important;
}
.rd-input.v-input--is-focused ::v-deep .v-label {
  color: var(--primary) !important;
}

.rd-input.v-input--is-focused ::v-deep .v-input__slot fieldset,
.rd-input.v-input--is-focused ::v-deep fieldset {
  border-color: var(--primary-light) !important;
  border-width: 2.5px !important;
}
.rd-input.v-input--is-focused ::v-deep .v-input__slot {
  box-shadow: 0 0 0 5px rgba(52, 126, 168, 0.18) !important;
  border-radius: var(--r-sm) !important;
}

.rd-input ::v-deep .v-input__append-outer {
  margin: 0 0 0 6px !important;
  align-self: center;
}
.rd-input ::v-deep .v-input__append-outer .v-icon {
  color: var(--primary) !important;
  font-size: 22px !important;
}

::v-deep .v-menu__content {
  border-radius: var(--r-sm) !important;
  box-shadow: 0 8px 24px rgba(17, 29, 45, 0.14) !important;
  border: 1px solid var(--border) !important;
}
::v-deep .v-menu__content .v-list {
  padding: 4px 0 !important;
}
::v-deep .v-menu__content .v-list-item {
  min-height: 40px !important;
  font-family: inherit !important;
  font-size: 13px !important;
  color: var(--text) !important;
}
::v-deep .v-menu__content .v-list-item--highlighted,
::v-deep .v-menu__content .v-list-item:hover {
  background: var(--primary-tint) !important;
}
::v-deep .v-menu__content .v-list-item__title {
  font-family: inherit !important;
  font-size: 13px !important;
}

/* Responsive */
@media (max-width: 900px) {
  .inline-form {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 600px) {
  .sale-setup {
    padding: 12px;
  }
  .inline-form {
    grid-template-columns: 1fr;
  }
}
@media (min-width: 1500px) {
  .sale-setup {
    padding: 16px 18px;
  }
  .field label {
    font-size: 15px;
  }
  .field input,
  .field select {
    height: 49px;
    font-size: 16px;
  }
  .rd-input ::v-deep .v-input__slot,
  .rd-input.v-text-field--outlined ::v-deep .v-input__slot {
    min-height: 49px !important;
    height: 49px !important;
  }
  .rd-input ::v-deep input {
    font-size: 16px !important;
  }
  .small-btn {
    font-size: 14px;
    padding: 12px 22px;
  }
  .toggle-btn {
    height: 49px;
    font-size: 14px;
  }
}
</style>